/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-color-palette block)");
/* eslint-enable no-console */

(function () {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.swatch-copy').forEach(function (btn) {
            btn.addEventListener('click', function () {
                copyHex(this, this.dataset.hex);
            });
        });
    });

    async function copyHex(btn, hex) {
        try {
            await navigator.clipboard.writeText(hex);
            const t = document.getElementById('toast');
            t.textContent = '✓ ' + hex + ' copied!';
            t.classList.add('show');
            btn.style.color = '#27ae60';
            btn.style.borderColor = '#27ae60';
            setTimeout(() => {
                t.classList.remove('show');
                btn.style.color = '';
                btn.style.borderColor = '';
            }, 1500);
        } catch (e) { }
    }
})()
